import React from 'react';

import { titlesByField } from '@/components/SuggestContent/hooks/useGroupEdit';
import { NotificationActionType, NotificationActionKind } from '@/types/user';

import Notification from '../Notification';

import * as styles from './styles.module.css';

const ContentChangeSuggestionApprovedNotification = ({
  notification,
  onClick,
}) => {
  const {
    action: { event, contentChange },
    timestamp,
  } = notification;
  const fieldTitle = contentChange?.type && titlesByField[contentChange?.type];
  const suggestionText = fieldTitle ? (
    <span>
      Your suggestion for{' '}
      <span className={styles.strong}>{fieldTitle.toLowerCase()}</span> has been
      approved!
    </span>
  ) : (
    <span>Your suggestion has been approved!</span>
  );
  const message = (
    <>
      {suggestionText}
      <br />
      <span>
        View <span className={styles.strong}>{event?.title}</span>
      </span>
    </>
  );
  const relativePermalink = `/e/${event?.id}?contentChangeId=${contentChange?.id}`;
  const action = {
    relativePermalink,
    message,
    kind: NotificationActionKind.APPROVED,
    type: NotificationActionType.CONTENT_CHANGE_SUGGESTION_APPROVED,
  };

  return <Notification {...{ action, timestamp, onClick }} />;
};

export default ContentChangeSuggestionApprovedNotification;
